import { useRequestMutation } from "hooks/useRequest";
import { History } from "models/AiResearch";

export const useChatDelete = ({
  replaceHistory
}: {
  replaceHistory: (history: History[]) => void;
}) => {
  const { trigger } = useRequestMutation<
    {
      historys: History[];
    },
    {
      talkId: string;
    }
  >("/sse/query/rag/history-delete", "POST", {
    onSuccess: data => {
      replaceHistory(data.historys ?? []);
    }
  });

  return { deleteChat: trigger };
};
